export const DECIMAL_PLACES = 2
export const DECIMAL_PLACES_PERCENTAGE = 4
